import React from "react"
import * as styles from "./SupplierSignupForm.module.scss"

const FormSocial = ({ data, handleChange }) => (
  <section>
    <h3>Social Media</h3>
    <p>
      (Optional) Social Media is a great way for our users to see what you have been up to and to
      show off your past work! Be sure to include the 'https://www...' as it would read in a web
      address.
    </p>

    <div className={styles.twoColumn}>
      <div>
        <label htmlFor="linkedin">Linkedin</label>
        <input
          type="url"
          id="linkedin"
          name="linkedin"
          onChange={handleChange}
          value={data.linkedin}
          placeholder="https://www.linkedin.com/company/yourprofile"
        />
      </div>
      <div>
        <label htmlFor="twitter">Twitter</label>
        <input
          type="url"
          id="twitter"
          name="twitter"
          onChange={handleChange}
          value={data.twitter}
          placeholder="https://twitter.com/yourprofile"
        />
      </div>
      <div>
        <label htmlFor="facebook">Facebook</label>
        <input
          type="url"
          id="facebook"
          name="facebook"
          onChange={handleChange}
          value={data.facebook}
          placeholder="https://www.facebook.com/yourprofile"
        />
      </div>
      <div>
        <label htmlFor="instagram">Instagram</label>
        <input
          type="url"
          id="instagram"
          name="instagram"
          onChange={handleChange}
          value={data.instagram}
          placeholder="https://www.instagram.com/yourprofile"
        />
      </div>
      <div>
        <label htmlFor="pinterest">Pinterest</label>
        <input
          type="url"
          id="pinterest"
          name="pinterest"
          onChange={handleChange}
          value={data.pinterest}
          placeholder="https://www.pinterest.com/yourprofile"
        />
      </div>
      <div>
        <label htmlFor="youtube">Youtube</label>
        <input
          type="url"
          id="youtube"
          name="youtube"
          onChange={handleChange}
          value={data.youtube}
          placeholder="https://www.youtube.com/channel/yourprofile"
        />
      </div>
    </div>
  </section>
)

export default FormSocial
